module.exports = __webpack_public_path__ + "static/media/import.cfc5dd9d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/gifshop/import.jpg
// module id = 234
// module chunks = 0